import { LOGSHEET_VIEW, LOGSHEET_EDIT } from '@/fixtures'

export default {
  path: 'log-sheet',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Log Sheet',
      component: () => import('@/views/menus/LogSheet/Index'),
      meta: {
        permission: LOGSHEET_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Log Sheet',
      component: () => import('@/views/menus/LogSheet/View'),
      meta: {
        permission: LOGSHEET_VIEW
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Log Sheet',
      component: () => import('@/views/menus/LogSheet/Edit'),
      meta: {
        permission: LOGSHEET_EDIT
      }
    }
  ]
}
